
// import AppBar from '@material-ui/core/AppBar';
// import Button from '@material-ui/core/Button';
// import Modal from '@material-ui/core/Modal';
// import React from 'react';
// import '../../stylesheet/regmodal.css';




// const RegModal = props => {

//     // const classes = useStyles();

//     return (
//         <Modal
//             open={props.open}
//             className="col-sm-12 flow-modal">
//             <div
//                 className="modal-content col-sm-4"
//                 style={{ background: "#fff", color: "#fff" }}>
//                 <div
//                     position="static"
//                     className="modal-header"
//                     style={{ background: "#fff", padding: "10px" }}>
//                     <div className="col-sm-12">
//                         <div className="row">
//                             {/* <div
//                                 className="col-sm-6"
//                                 style={{ fontSize: "19px", fontWeight: "600", color: "#fff" }}>
//                                 <span>Status</span>
//                             </div> */}
//                             <div
//                                 className="col-sm-12"
//                                 style={{ float: "right" }}>
//                                 <button
//                                     type="button"
//                                     className="close"
//                                     data-dismiss="modal"
//                                     style={{ marginTop: "-19px", color: "#333" }}
//                                     onClick={props.onClose}
//                                     aria-label="Close">
//                                     <span
//                                         aria-hidden="true"
//                                         style={{ color: "#333", fontSize: "30px" }}>
//                                         &times;
//                                     </span>
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//                 <div
//                     className="modal-body text-left"
//                     style={{ color: "#3e3e3e" }}>
//                     <div className="col-sm-12">
//                         <div className="col-sm-12" >
//                             <i
//                                 className="fa fa-question fa-4x mb-3 animated rotateIn"
//                                 style={{ color: "#323435" }}>
//                             </i>
//                         </div>
//                         <div
//                             className="col-sm-12"
//                             style={{ fontSize: "20px", fontWeight: "600", marginBottom: "15px" }}>
//                             Are you an existing user?
//                         </div>
//                         {/* <div
//                             className="col-sm-12"
//                             style={{ fontSize: "13px", textAlign: "justify", marginBottom: "15px" }}>
//                             Once created, your program will be inactive. Do you want to add fee to your program?
//                         </div> */}
//                         <div className="col-sm-12" style={{ fontSize: "14px" }}>
//                             <div className="row col-md-12" style={{ display: "flex", justifyContent: "left" }}>
//                                 <div className="mr-3">
//                                     <Button className="btn btn-std"  onClick={props.handleOld} >
//                                         Yes
//                                     </Button>
//                                 </div>
//                                 <div className="" >
//                                     <Button className="btn btn-std" onClick={props.handleNew} >
//                                         No
//                                     </Button>
//                                 </div>

//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </Modal>
//     )
// }

// export default RegModal




import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import React from 'react';
import '../../stylesheet/regmodal.css';
 
const RegModal = props => {
  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        className="modal-content"
        style={{
          background: '#fff',
          color: '#3e3e3e',
          maxWidth: '500px',
          width: '90%',
          maxHeight: '90vh',
          overflowY: 'auto',
          outline: 'none',
          border: 'none',        
          borderRadius: '4px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
          position: 'static',    
          top: 'auto',
          margin: 0,
        }}
      >
        <div className="modal-header" style={{ background: '#fff', padding: '10px', border: 'none' }}>
         
        </div>
 
        <div className="modal-body text-left" style={{ color: '#3e3e3e' }}>
          <div className="col-sm-12">
            <i
              className="fa fa-question fa-4x mb-3 animated rotateIn"
              style={{ color: '#323435' }}
            />
          </div>
          <div
            className="col-sm-12"
            style={{ fontSize: '20px', fontWeight: '600', marginBottom: '15px' }}
          >
 Are you an existing user?
           </div>
          <div className="col-sm-12" style={{ fontSize: '14px' }}>
            <div className="row col-md-12" style={{ display: 'flex', justifyContent: 'left' }}>
              <div className="mr-3">
                <Button className="btn btn-std" onClick={props.handleOld}>
                  Yes
                </Button>
              </div>
              <div>
                <Button className="btn btn-std" onClick={props.handleNew}>
                  No
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
 
export default RegModal;
 


// WEBPACK FOOTER //
// ./src/components/register/regmodal.jsx